import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class VariantMetafieldChipComponent extends Component {
  requiredRefs = ['chipContainer', 'metafieldData'];

  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    if (!target) return;
    target.addEventListener(ThemeEvents.variantUpdate, this.updateChip);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    if (!target) return;
    target.removeEventListener(ThemeEvents.variantUpdate, this.updateChip);
  }

  updateChip = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    }

    if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const variantId = event.detail.resource?.id;
    const values = this.metafields[String(variantId)];

    if (values === undefined && event.detail.data.html) {
      const updatedComponent = Array.from(event.detail.data.html.querySelectorAll('variant-metafield-chip-component')).find(
        (component) => component.dataset.fieldId === this.dataset.fieldId
      );
      const updatedContainer = updatedComponent?.querySelector('[ref="chipContainer"]');

      if (updatedContainer) {
        this.refs.chipContainer.replaceChildren(...Array.from(updatedContainer.children).map((child) => child.cloneNode(true)));
        this.style.display = updatedContainer.children.length > 0 ? 'block' : 'none';
        return;
      }
    }

    const normalizedValues = Array.isArray(values) ? values : [values];
    const cleanValues = normalizedValues.filter((value) => value !== null && value !== undefined && String(value).trim() !== '');
    const chipValues = Array.isArray(values)
      ? cleanValues.length
        ? [cleanValues.map((value) => this.formatValue(String(value))).join(', ')]
        : []
      : cleanValues.map((value) => this.formatValue(String(value)));

    this.refs.chipContainer.replaceChildren(...chipValues.map((value) => this.createChip(value)));
    this.style.display = cleanValues.length > 0 ? 'block' : 'none';
  };

  get metafields() {
    try {
      return JSON.parse(this.refs.metafieldData.textContent || '{}');
    } catch {
      return {};
    }
  }

  createChip(value) {
    const chip = document.createElement('span');
    chip.className = 'variant-metafield-chip__chip';
    chip.dataset.testid = 'variant-metafield-chip';

    const iconTemplate = this.querySelector('template[data-chip-icon-template]');
    const icon = iconTemplate?.content.firstElementChild?.cloneNode(true);

    if (icon) {
      chip.append(icon);
    }

    if (this.dataset.label) {
      const label = document.createElement('b');
      label.textContent = `${this.dataset.label}:`;
      chip.append(label);
    }

    chip.append(value);
    return chip;
  }

  formatValue(value) {
    const suffix = this.dataset.valueSuffix?.trim();
    return suffix ? `${value}\u00a0${suffix}` : value;
  }
}

if (!customElements.get('variant-metafield-chip-component')) {
  customElements.define('variant-metafield-chip-component', VariantMetafieldChipComponent);
}
